import type { RouteRecordRaw } from 'vue-router';

export const error: RouteRecordRaw = {
	component: () => import('components/modules/Error.vue'),
	name: 'error',
	path: '/error/:id',
	meta:{ title: 'Nicht vorhanden' },
	props: true,
}
